import { render, staticRenderFns } from "./DeliveryCarEditDlg.vue?vue&type=template&id=4f12d668&scoped=true"
import script from "./DeliveryCarEditDlg.vue?vue&type=script&lang=js"
export * from "./DeliveryCarEditDlg.vue?vue&type=script&lang=js"
import style0 from "./DeliveryCarEditDlg.vue?vue&type=style&index=0&id=4f12d668&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f12d668",
  null
  
)

export default component.exports